import useDirection from "./useDirection";
interface options {
  toLocal?: boolean;
}
const useDate = () => {
  const { lng } = useDirection();

  const toLocalDateAndTimeString = (
    date: any,
    options?: Intl.DateTimeFormatOptions
  ) => {
    if (!date) return;
    let newDate = new Date(date);
    const { hour = "numeric", minute = "numeric" } = options || {};
    return `${newDate.toLocaleTimeString(
      lng || "fa-IR",
      options
    )} - ${newDate.toLocaleDateString(lng || "fa-IR", options)}`;
  };
  return { toLocalDateAndTimeString };
};

export default useDate;
